<template>
  <div >
    <div style="float:left;" v-if="totalElements > 0">
      <nav aria-label="Page navigation example">
        <ul class="pagination pagination-sm pagination-torre">
          <li class="page-item disabled" >
            <a class="page-link" href="#" tabindex="-1">
              Liczba elementów: {{ totalElements }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="container" v-if="showPagination">
      <div class="row align-items-center justify-content-center">
        <div class="col-auto">
          <nav aria-label="Page navigation example">
            <ul class="pagination pagination-sm pagination-torre">
              <li class="page-item" @click.prevent="onPrevClicked()" v-if="showPrev">
                <a class="page-link" href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
                </a>
              </li>
              <li class="page-item disabled" >
                <a class="page-link" href="#" tabindex="-1">Strona {{ currentPage }} z {{ totalPages }}</a>
              </li>
              <li class="page-item" @click.prevent="onNextClicked()" v-if="showNext">
                <a class="page-link" href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommonPagination",
  data: () => ({
    data: {},
    totalPages: 0,
    currentPage: -1,
    isFirst: false,
    isLast: false
  }),
  created: function() {
    this.$parent.$on('dataChanged', this.onDataChanged);
  },
  destroyed: function() {
    this.$parent.$off('dataChanged');
  },
  computed: {
    totalElements: function() {
      this.data.page = this.data.page || {}
      return this.data.page.totalElements || 0
    },
    showNext: function() {
      return !this.isLast;
    },
    showPrev: function() {
      return !this.isFirst;
    },
    showPagination: function() {
      return this.totalPages > 1;
    }
  },
  methods: {
    scrollTop: function () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    onPrevClicked: function () {
      var pageToSend = this.currentPage - 1 - 1;
      this.emitPageVent(pageToSend);
      this.scrollTop();
    },
    onNextClicked: function() {
      var pageToSend = this.currentPage + 1 - 1;
      this.emitPageVent(pageToSend);
      this.scrollTop();
    },
    onDataChanged(payload) {
      this.data = payload.data;
      this.assignLinksInfo();
    },
    emitPageVent: function(pageToSend) {
      this.$emit("paginationClicked", {
        pageToSend: pageToSend
      });
    },
    assignLinksInfo: function() {
      this.currentPage = this.data.page.number + 1;
      this.totalPages = this.data.page.totalPages;
      this.isFirst = this.currentPage == 1;
      this.isLast = this.currentPage == this.totalPages;
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pagination/CommonPagination.vue